export class NoticeType {
  static get NewInstall () {
    return 1
  }
  static get ReturnInstall () {
    return 2
  }
  static get MoveInstall () {
    return 3
  }
  static get TryInstall () {
    return 4
  }
  static get AutoMakeNewInstall () {
    return 100
  }
  static get AutoMakeReturnInstall () {
    return 101
  }
  static get AutoMakeMoveInstall () {
    return 102
  }
  static get AutoMakeTryInstall () {
    return 103
  }

  static getFormNoticeTypeName (NoticeType) {
    let tmpType = parseInt(NoticeType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = '新裝'
        break
      case 2:
        name = '回裝'
        break
      case 3:
        name = '移機-裝'
        break
      case 4:
        name = '試裝'
        break
      case 100:
        name = '自動產生-新裝'
        break
      case 101:
        name = '自動產生-回裝'
        break
      case 102:
        name = '自動產生-移機(裝)'
        break
      case 103:
        name = '自動產生-試裝(裝)'
        break
    }
    return name
  }
}
